import type { CbSubscription } from '@lmc/common/types'
import { groupBy } from 'lodash'

const CANCELLED_STATUS = 'cancelled'

export const filterDuplicateSubscriptions = (
  subscriptions: CbSubscription[]
) => {
  const currentSubscriptions = subscriptions?.filter(
    (item) => item.status !== CANCELLED_STATUS
  )

  const subscriptionsWithIdentifier = currentSubscriptions?.map((item) => {
    const plan_id = item.subscription_items?.[0]?.item_price_id || item?.plan_id
    let planIdentifier = plan_id.split('-')[0]
    // care-plans and pro have merged
    if (planIdentifier === 'care') {
      planIdentifier = 'pro'
    }

    return {
      ...item,
      planIdentifier
    }
  })

  const uniqueSubscriptions: CbSubscription[] = []

  Object.values(groupBy(subscriptionsWithIdentifier, 'planIdentifier')).forEach(
    (group) => {
      if (group[0]) {
        uniqueSubscriptions.push(group[0])
      }
    }
  )

  return uniqueSubscriptions
}
